import {
  CLIENT_BACKUPS,
  CLIENT_BACKUP_PORTAL,
  CLIENT_BACKUP_USERS,
  CLIENT_CASES,
  CLIENT_DASHBOARD,
  CLIENT_EXPLORER,
  CLIENT_HISTORY,
  CLIENT_ORDERS,
  CLIENT_PLANNING,
  CLIENT_PRICES,
  CLIENT_PROJECTS,
  CLIENT_LISTS,
  CLIENT_REPORTING,
  CLIENT_SUPPORT,
  CLIENT_USERS,
  CLIETN_COMPANIES,
  CLIETN_HOME,
} from 'src/constants/constants';

const BACKUP_PORTAL_PATH = '/mindtime/backup-portal';

type LandingRoute = {
  permission: string;
  path: string;
};

export const PERMISSION_LANDING_FALLBACK = '/401';

// Keep this priority aligned with DashboardSidebar order.
export const permissionLandingPriority: LandingRoute[] = [
  { permission: CLIENT_DASHBOARD, path: '/cases/dashboard' },
  { permission: CLIENT_CASES, path: '/cases/all' },
  { permission: CLIENT_PROJECTS, path: '/projects' },
  { permission: CLIETN_COMPANIES, path: '/clients' },
  { permission: CLIENT_ORDERS, path: '/orders' },
  { permission: CLIENT_REPORTING, path: '/reporting' },
  { permission: CLIENT_PLANNING, path: '/planning' },
  { permission: CLIENT_USERS, path: '/contacts' },
  { permission: CLIETN_HOME, path: '/mindtime/home' },
  { permission: CLIENT_BACKUPS, path: '/mindtime/my-backups' },
  { permission: CLIENT_EXPLORER, path: '/mindtime/support' },
  { permission: CLIENT_BACKUP_USERS, path: '/mindtime/users' },
  { permission: CLIENT_PRICES, path: '/mindtime/prices' },
  { permission: CLIENT_LISTS, path: '/mindtime/lists' },
  { permission: CLIENT_HISTORY, path: '/mindtime/history' },
  { permission: CLIENT_SUPPORT, path: '/mindtime/support' },
  { permission: CLIENT_BACKUP_PORTAL, path: BACKUP_PORTAL_PATH },
];

export const getPermissionLandingPath = (
  permissions: string[] = []
): string | null => {
  const firstAllowedRoute = permissionLandingPriority.find(({ permission }) =>
    permissions.includes(permission)
  );

  return firstAllowedRoute?.path ?? null;
};

export const getPermissionLandingPathOrFallback = (
  permissions: string[] = [],
  fallback = PERMISSION_LANDING_FALLBACK
): string => getPermissionLandingPath(permissions) ?? fallback;

export const ONBOARDING_CREATE_PATH = '/organizations/create';

type AuthenticatedLandingUser = {
  permissions?: string[];
  organization?: { isOnBoarded?: boolean };
};

/** Post-login / post-auth route: onboarding wizard or permission-based dashboard. */
export const getAuthenticatedLandingPath = (
  user: AuthenticatedLandingUser | null | undefined
): string => {
  if (user?.organization?.isOnBoarded === false) {
    return ONBOARDING_CREATE_PATH;
  }

  return getPermissionLandingPathOrFallback(user?.permissions ?? []);
};
